import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  ${mediaQueries.tablet} {
    row-gap: 20px;
  }
`
